import React, { useContext } from 'react';
import paypalImage from '../../../images/paypal.svg';
import { ConfigContext } from '../../../context/Config';
import Button from '../../Button';
import { loadStripe } from '@stripe/stripe-js/pure';
import '../Checkout.less';

loadStripe.setLoadParameters({ advancedFraudSignals: false });

export type StripeProps = {
  onSelect?: (type: string) => void;
};

const TPaypal: React.FC<StripeProps> = ({ onSelect }) => {
  const { translate } = useContext(ConfigContext);
  return (
    <div className="t-payment t-payment-paypal">
      <img
        src={paypalImage}
        alt="accepted_cards"
        onClick={() => onSelect('paypal')}
      />
    </div>

    // <Button
    //   fullWidth
    //   htmlType="button"
    //   className="t-payment t-payment-stripe"
    //   onClick={() => onSelect('stripe')}
    // >
    //   {translate('Click to redirect payment page')}
    // </Button>
  );
};

export default TPaypal;
